import {
  mapGetters,
  mapActions,
  mapMutations
} from 'vuex'

import * as authStore from '@/store/auth'

export {
  authStore
}

/**
 * Search store.
 *
 * @param {('actions' | 'getters' | 'mutations')[]} without - Exclude store actions or mutation or getters.
 */
export const createAuthStoreMixin = (without = []) => {
  const actions = !without.includes('actions') ? mapActions(authStore.moduleName, Object.keys(authStore.actionTypes)) : {}
  const getters = !without.includes('getters') ? mapGetters(authStore.moduleName, Object.keys(authStore.getterTypes)) : {}
  const mutations = !without.includes('mutations') ? mapMutations(authStore.moduleName, Object.keys(authStore.mutationTypes)) : {}

  return {
    methods: {
      ...actions,
      ...mutations
    },
    computed: {
      ...getters
    }
  }
}
